export default "__VITE_ASSET__BDLBFZLB__"